const initialTasksState = {
  tasks: [],
};

export default initialTasksState;
